var map = {
	"./NextJS.png": 6923,
	"./c-.png": 4249,
	"./express.png": 2717,
	"./figma.png": 2409,
	"./logo.png": 8280,
	"./mongo.png": 8789,
	"./node.png": 6317,
	"./physics.png": 5438,
	"./python.png": 7643
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3461;